import { useState, useEffect } from 'react';

export const useTelegramSubscription = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const subscriptionKey = 'telegramSubscription';

  useEffect(() => {
    const storedSubscription = localStorage.getItem(subscriptionKey);
    if (storedSubscription) {
      setIsSubscribed(true);
    }
  }, []);

  const handleSubscribe = () => {
    localStorage.setItem(subscriptionKey, 'true');
    setIsSubscribed(true);
  };

  return { isSubscribed, handleSubscribe };
};